<template>
  <div class="compteur mt-2">
    <transition mode="out-in" name="slide-fade">
      <span class="d-block" v-if="!$store.state.isLoading" key="asd"
        ><span v-if="$store.state.page_type != 'search'"
          >{{ $store.state.posts.length }} / </span
        >{{ $store.state.wp_total }} {{ result_word }}</span
      ><span
        v-else
        class="d-block"
        v-html="$store.state.i18n.searching"
        key="asf"
      ></span>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Compteur",

  computed: {
    result_word() {
      if (this.$store.state.posts.length > 1) {
        return this.$store.state.i18n.results;
      }

      return this.$store.state.i18n.result;
    },
  },
};
</script>
